import { useAvatarUrl } from '../avatars';

/** A player's square avatar. Decorative: the name is always shown beside it. */
export function Avatar({ playerId, className }: { playerId: number; className?: string }) {
  return <img src={useAvatarUrl(playerId)} alt="" className={`avatar${className ? ` ${className}` : ''}`} />;
}
